import React, {useMemo} from 'react';
import {useParams} from 'react-router';
import DisclosureDocumentHeader from '../../../../components/prosemirror-editor/components/DisclosureDocumentHeader';
import ReportEditor from '../../reportEditorPage/reportEditor/ReportEditor';

/**
 * Specialized disclosure editor that reuses the shared report editor runtime.
 */
export default function DisclosureEditor() {
    const {reportId} = useParams();

    const documentHeader = useMemo(
        () => <DisclosureDocumentHeader documentId={reportId} />,
        [reportId],
    );

    return (
        <ReportEditor
            containerClassName="disclosure-editor-container"
            documentHeader={documentHeader}
        />
    );
}
